import React from "react";
import { useStyles } from "./style";
import PopUpModal from "../../../../SharedComponents/PopUpModal";
import { Spinner } from "react-bootstrap";

const ScorePopup = ({
  showSubmitScorePopup,
  handleSubmitScore,
  handlePopupVisibility,
  score,
  handleScoreChange,
  maxScore,
  showScoreLoader,
}) => {
  const classes = useStyles();
  return (
    <PopUpModal
      open={showSubmitScorePopup}
      okBtnText={"Submit Score"}
      cancelBtnText={"Cancel"}
      title={"Score"}
      showCloseIcon={false}
      handleOkBtn={() => handleSubmitScore(maxScore)}
      handleCancelBtn={() => handlePopupVisibility("close")}
    >
      {showScoreLoader ? (
        <div className={classes.spinnerContainer}>
          <Spinner animation="border" variant="orange" />
        </div>
      ) : (
        <div className={classes.inputWrapper}>
          <input
            type="text"
            className={classes.realInput}
            value={score}
            onChange={(e) => handleScoreChange(e, maxScore)}
          />
          <div
            className={`${classes.customPlaceholder} ${
              score ? classes.hidden : ""
            }`}
          >
            <span>Enter score</span>
            <span className={classes.rightPlaceholder}>
              (max score - {maxScore})
            </span>
          </div>
        </div>
      )}
    </PopUpModal>
  );
};

export default ScorePopup;
